'use client';

import type { FragmentType } from '~/shared/codegen/fragment-masking';
import { useFragment } from '~/shared/codegen/fragment-masking';
import ContentPlaceholder from '~/shared/components/content-placeholder';
import Link from '~/shared/components/link';
import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getUrl } from '~/shared/helpers/string-helpers';

import { PopularArticlesItemFragment } from '../blog-menu/helpers/blog-menu-cache';

type PopularArticleItemProps = Readonly<{
  lng: Locale;
  error: boolean;
  loading: boolean;
  item: FragmentType<typeof PopularArticlesItemFragment> | null;
}>;

const PopularArticleItem = ({ closeDropdown, lng, error, loading, item }: PopularArticleItemProps) => {
  const post = useFragment(PopularArticlesItemFragment, item);

  return (
    <Link
      className="popular-articles__list-item"
      itemProp="url"
      onClick={closeDropdown}
      href={loading || !post?.alias ? '#' : getLocaleLink(getUrl({ link: PAGE_NAMES.POST, alias: post.alias }), lng)}
    >
      <ContentPlaceholder
        height="80px"
        className="popular-articles__image"
        isLoading={loading}
        isError={error}
        content={
          <div
            className="popular-articles__image"
            style={{
              background: `url(${post?.image?.path ?? ''}) center / cover no-repeat`,
            }}
          />
        }
      />

      <div className="popular-articles__text">
        <ContentPlaceholder isLoading={loading} isError={error} content={post?.title ?? ''} />
      </div>
    </Link>
  );
};

export default PopularArticleItem;
